import fetch from "node-fetch";
import type {GetData, StateAny} from "../bookingflowstatemachine/bookingflowstatemachine.types";
import { Address } from "@raskrask-dk/raskrask-utils";

class SuggestionMapper {
  async fromAny(obj: any): Promise<GetData<StateAny>> {
    const {address: addressIn, ...rest} = obj;
    const address = addressIn !== undefined ? await this.addressFromString(addressIn) : undefined;
    const customer = this.customerFromObj(obj);

    const getData = {
      ...rest,
      ...(address !== "NO_ADDRESS" && {address: address}),
      ...customer,
    };
    return getData;
  }

  customerFromObj(obj: any) {
    const {
      specialNeeds,
      problemDescription,
      acceptConditions,
      customerName,
      customerPhone: customerPhoneStr,
      customerEmail,
      promoCode,
      klippeCardCode,
      parkingText,
      companyAdminName,
      companyName,
      giftCard,
    } = obj;

    const customerPhone = customerPhoneStr !== undefined ? parseInt(customerPhoneStr.match(/\d/g).join("")) : undefined;

    const customer = {
      specialNeeds,
      problemDescription,
      acceptConditions,
      customerName,
      ...(customerPhoneStr && {customerPhone: customerPhone}),
      customerEmail,
      promoCode,
      klippeCardCode,
      parkingText,
      companyAdminName,
      companyName,
      giftCard,
    };
    return customer;
  }

  /**
   * @param stringAddress - intended to come from "dawa autocomplete" and the "forslagstekst".
   * @returns the first address from dawa autocomplete or "NO_ADDRESS" if no addresses found
   */
  async addressFromString(stringAddress: string): Promise<Address | "NO_ADDRESS"> {
    const url = `https://dawa.aws.dk/autocomplete/?q=${stringAddress}`;
    const addresses = (await (await fetch(url)).json()) as DawaAutoCompleteResponse;
    if (addresses.length === 0) return "NO_ADDRESS";
    if (addresses[0].type !== "adresse") return "NO_ADDRESS";
    const addressDTO = addresses[0];
    const {
      forslagstekst,
      data: {postnr, etage: etageOut, y: geoLat, x: geoLng},
    } = addressDTO;
    const etage = etageOut === null ? "0" : etageOut;
    const address = new Address(forslagstekst, geoLat.toString(), geoLng.toString(), parseInt(postnr), etage);
    return address;
  }
}

export {SuggestionMapper};

type DawaAutoCompleteResponse = DawaAutoCompleteAddress[] | DawaAutoCompleteVejnavn[];
type DawaResultType = "adresse" | "vejnavn";
interface DawaResponse {
  type: DawaResultType;
}
type DawaAutoCompleteAddress = {
  data: {
    id: string;
    status: number;
    darstatus: number;
    vejkode: string;
    vejnavn: string;
    adresseringsvejnavn: string;
    husnr: string;
    etage: string;
    dør: null;
    supplerendebynavn: null;
    postnr: string;
    postnrnavn: string;
    stormodtagerpostnr: null;
    stormodtagerpostnrnavn: null;
    kommunekode: string;
    adgangsadresseid: string;
    x: number;
    y: number;
    href: string;
  };
  stormodtagerpostnr: false;
  type: string;
  tekst: "addresse";
  forslagstekst: string;
  caretpos: number;
} & DawaResponse;

type DawaAutoCompleteVejnavn = {
  type: "vejnavn";
  tekst: string;
  forslagstekst: string;
  caretpos: number;
  data: {
    navn: string;
    href: string;
  };
} & DawaResponse;
